var angular = require('angular');
var _module = require('./index');

require('../core/utils');
require('../events');


_module.requires.push(
    'listreports.core',
    'listreports.events'
);

_module.controller('LeadFormCtrl', [
    '$scope',
    '$utils',
    '$location',
    '$http',
    '$events',

    function LeadFormCtrl($scope, $utils, $location, $http, $events){
        var API_URL = "https://www.listreports.com";
        $scope.forms = {};
        $scope.leadForm = {};

        $scope.submitLeadForm = function(e) {
            if($scope.forms.leadForm.$invalid) return;

            $scope.showFullscreenLoader();

            var data = {
                name: $scope.leadForm.data.name,
                email: $scope.leadForm.data.email,
                phone: $scope.leadForm.data.phone,
                property_url: $location.absUrl(),
                report_id: $scope.report.id,
                type: $scope.leadType,
                source: $scope.leadSource
            };

            $events.track('Lead Form Submit', {
                Source: $scope.companyTypeMap[$scope.companyType].leadForm.modalTitle
            });

            $http.post(API_URL + '/v1/vendor/lead', data)
                .success(function() {
                    $scope.hideFullscreenLoader();
                    $scope.showThankYouMessage = true;
                })
                .error(function(err) {
                    $scope.hideFullscreenLoader();

                    console.log('Get Financed Error', err);

                    alert('There was a problem submitting the form. If this problem persists please contact us at support@listreports.com');
                })
            ;
        };
    }
]);

_module.directive('leadForm', [
    '$utils',
    '$location',
    '$http',
    '$events',

    function($utils, $location, $http, $events) {
        return {
            restrict: 'E',
            replace: true,
            scope: true,
            controller: 'LeadFormCtrl',
            templateUrl: 'js/components/modals/templates/lead-form.tmpl.html',
            link: function($scope, elem, attrs) {

                $scope.leadForm            = {};
                $scope.showThankYouMessage = false;
                $scope.title = 'Lead Form';
                $scope.subtitle = 'Provide your contact info to get in touch!';
                $scope.thankYouMessage = 'Someone will be in touch shortly.';
                $scope.leadType = $scope.$eval(attrs.type);
                $scope.leadSource = $scope.$eval(attrs.source);


                // $scope Functions

                // Moved the function definition to the controller LeadFormCtrl
                // since $scope.leadForm is not bound to the form in the DOM in this link fn
                // - Amish 2018-12-28

                /*$scope.submitLeadForm = function(e) {
                    if($scope.leadForm.$invalid) return;

                    $scope.showFullscreenLoader();

                    var data = {
                        name: $scope.leadForm.data.name,
                        email: $scope.leadForm.data.email,
                        phone: $scope.leadForm.data.phone,
                        property_url: $location.absUrl(),
                        report_id: $scope.report.id,
                        type: $scope.$eval(attrs.type),
                        source: $scope.$eval(attrs.source)
                    };

                    $events.track('Lead Form Submit', {
                        Source: $scope.companyTypeMap[$scope.companyType].leadForm.modalTitle
                    });

                    $http.post(API_URL + '/v1/vendor/lead', data)
                        .success(function() {
                            $scope.hideFullscreenLoader();
                            $scope.showThankYouMessage = true;
                        })
                        .error(function(err) {
                            $scope.hideFullscreenLoader();

                            console.log('Get Financed Error', err);

                            alert('There was a problem submitting the form. If this problem persists please contact us at support@listreports.com');
                        })
                    ;
                };*/

                // $watch Functions
                if(attrs.title) {
                    $scope.$watch(attrs.title, function(value) {
                        if(value)
                            $scope.title = value;
                    });
                }

                $scope.$watch(attrs.subtitle, function(value) {
                    if(value)
                        $scope.subtitle = value;
                });

                $scope.$watch(attrs.thankYouMessage, function(value) {
                    if(value)
                        $scope.thankYouMessage = value;
                });

                $scope.$watch(attrs.hideTitle, function(value) {
                    $scope.hideTitle = !!value;
                });
            }
        };
    }
]);